import { render, staticRenderFns } from "./ConversationList.vue?vue&type=template&id=b30cecb6&scoped=true"
import script from "./ConversationList.vue?vue&type=script&lang=js"
export * from "./ConversationList.vue?vue&type=script&lang=js"
import style0 from "./ConversationList.vue?vue&type=style&index=0&id=b30cecb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30cecb6",
  null
  
)

export default component.exports